// Dependencies
import React from 'react';
import _ from 'lodash';
import { Helpers } from '../utils';
import { CSSTransition } from 'react-transition-group'
import { CSSTransitionProps } from 'react-transition-group/CSSTransition'

// Contexts
import MinicartProvider from '../contexts/Minicart';
 
// Components 
 
// Types
import { Containers, Types } from '../types';  
import styled, { css, ThemeProvider } from 'styled-components';
import { useDebug } from '../hooks/useDebug'; 
import CartHeader from '../components/CartHeader';
import CartSidebar from '../components/CartSidebar';
import { useWindowResize } from '../hooks';
import { log } from 'console';
 
const Minicart = ({loading, errors, data: {notices, ...data}, ...props}: any) => {    

    const {} = useWindowResize(true); // NOTE: Multiple apps may provide this

    return (
        // TODO: Handle add to cart from here (probably) 
        <ThemeProvider theme={props.theme}>
            <MinicartProvider {...{...props, data, loading, config: {...props.config, notices: {...props.config.notices, ...notices}}}}>
                <CartHeader className="wooptima-cart-header" icon="ico-cart-default" />
                {props.config.general.minicartEnabled && <CartSidebar className="wooptima-minicart-sidebar"/> }
            </MinicartProvider>
        </ThemeProvider> 
    )

}
    
export default Minicart; 
    
     
